import { ShiftSlot } from '../../../shared/types/shiftTypes';


export const DEFAULT_COLOR = '#dac400';
export const MORNING_COLOR = 'rgb(59, 151, 238)';
export const EVENING_COLOR = 'rgba(218, 168, 5, 1)';
export const NIGHT_COLOR = 'rgb(150, 150, 150)';

export function getShiftSlotColor(shiftSlot: ShiftSlot | null): string {
    const color = shiftSlot === 'morning' ? MORNING_COLOR
        : shiftSlot === 'evening' ? EVENING_COLOR
            : shiftSlot === 'night' ? NIGHT_COLOR
                : DEFAULT_COLOR;
    return color;
}
